module.exports = __webpack_public_path__ + "static/media/footerMrPay.3c0fb82f.svg";